/*
 * Copyright 2024 NewMedia Centre - Delft University of Technology
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use server'

// import dependencies
import { prisma } from '@/db'
import { z } from 'zod'
import { webAppEditProcedure, webAppManageProcedure, webAppSchema } from './procedures'

/** Updates a web app */
export const updateAction = webAppEditProcedure.createServerAction()
	.input(z.object({
		name: z.string(),
		url: z.string().url(),
		summary: z.string().optional(),
		description: z.string().optional(),
		instructions: z.string().optional(),
		tags: z.array(z.string())
	}))
	.output(webAppSchema)
	.handler(async ({ input }) => {
		// update the app
		return await prisma.webApp.update({
			where: {
				id: input.id
			},
			data: {
				name: input.name,
				url: input.url,
				summary: input.summary,
				description: input.description,
				instructions: input.instructions,
				tags: input.tags
			}
		})
	})

/** Updates a web app's slug */
export const updateSlugAction = webAppManageProcedure.createServerAction()
	.input(z.object({
		slug: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
	}))
	.output(webAppSchema)
	.handler(async ({ input }) => {
		// update the app
		return await prisma.webApp.update({
			where: {
				id: input.id
			},
			data: {
				slug: input.slug,
			}
		})
	})